import { generateClient } from 'aws-amplify/api';
import { fetchAuthSession } from 'aws-amplify/auth';
import fetch from "../../../helpers/fetch";
import {
    SubscribeToPaymentStatusUpdate,
  } from '../Queries';

const client = generateClient();

const AppSyncApis = {
    getCognitoId: () => fetchAuthSession().then((session) => session.credentials),
    getIpAddress: () => {
      return fetch('https://jsonip.com/', { method: 'GET' }).then((response) => response.json())
    },

    SubscribeToPaymentStatusUpdate: (billReferenceNumber) => {
      return client.graphql({
        query: SubscribeToPaymentStatusUpdate,
        variables: { billReferenceNumber },
      });
    },
}

export default AppSyncApis;
